import { IoMdClose } from 'react-icons/io';
import { RoomObjectType } from '../../types/room';
import { GiMouse } from 'react-icons/gi';

const LandingPage = ({
  close,
  collabNFTS,
  suggestedNFTS,
}: {
  close: () => void;
  collabNFTS: RoomObjectType[];
  suggestedNFTS: RoomObjectType[];
}) => {
  // TODO: MAP NFTS
  return (
    <div className="landing-page">
      {/* <div className="landing-page-background " /> */}
      <div className="landing-page-main-container">
        <IoMdClose className="langing-page-close" size={50} onClick={close} />
        <div className="langing-page-header">Welcome to the Genesis Hotel!</div>
        <div className="langing-page-description">
          Click any of the rooms below to start exploring the Genesis Hotel and
          the world of Habbo X. You can also use the Hotel Navigator to the left
          to browse between the different floors available.
        </div>
        <div className="landing-page-controls">
          Controls:
          <GiMouse size={32} />
          <div>
            <div>Use left button to select rooms</div>
            <div>Use right button for panning</div>
            <div>Use mouse scroll wheel to zoom in/out</div>
            <div>Use Escape key as a general reset key</div>
          </div>
        </div>
        {/* <div className="langing-page-section-header">
          Official rooms and collabs
        </div>
        <div className="langing-page-section">
          <div>
            <div
              className="landing-page-room-container"
              style={{
                background: `linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 0, 0, 0.2) 100%
              ),
              url(${'path-to-image'}),
               -251.262px -262.989px / 206.29% 245.022% no-repeat`,
              }}
            ></div>
          </div>
          <div>
            <div
              className="landing-page-room-container"
              style={{
                background: `linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 0, 0, 0.2) 100%
              ),
              url(${'path-to-image'}),
               -251.262px -262.989px / 206.29% 245.022% no-repeat`,
              }}
            ></div>
          </div>
        </div>
        <div className="langing-page-section-header">Suggested rooms</div>
        <div className="langing-page-section">
          <div>
            <div
              className="landing-page-room-container"
              style={{
                background: `linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 0, 0, 0.2) 100%
              ),
              url(${'path-to-image'}),
               -251.262px -262.989px / 206.29% 245.022% no-repeat`,
              }}
            ></div>
          </div>
          <div>
            <div
              className="landing-page-room-container"
              style={{
                background: `linear-gradient(
                0deg,
                rgba(0, 0, 0, 0.2) 0%,
                rgba(0, 0, 0, 0.2) 100%
              ),
              url(${'path-to-image'}),
               -251.262px -262.989px / 206.29% 245.022% no-repeat`,
              }}
            ></div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default LandingPage;
